import * as React from 'react';
import Divider from '@material-ui/core/Divider';
import { getText, cloneDeep, getConfig } from '../../../helpers';
import DataFilterOption from './data-filter-option';
import Button from '../../_common/button';
import { ModalContext } from '../../_common/modal/modal';

const clearAllText = getText('generic.clearAll');
const applyText = getText('generic.apply');
const filterText = getText('generic.filter');
const filterOptions = getConfig('components.filterOptions');

const DataFilterOptions = ({ applyFilters, filters, handleClearAll }: DataFiltersProps) => {
    const onCloseContext = React.useContext(ModalContext);

    const localFilters = cloneDeep(filters);

    const onClearAll = (event: React.SyntheticEvent) => {
        event.preventDefault();
        handleClearAll();
        onCloseContext();
    };

    const onApply = (event: React.SyntheticEvent) => {
        event.preventDefault();
        applyFilters(localFilters);
        onCloseContext();
    };

    const onUpdate = () => {
        // const onUpdate = (filterItems: FilterCheckBoxItem[], filterTitle: string) => {
        // console.log(filterItems, filterTitle);
    };

    return (
        <div className="data-filter" data-testid="data-filter">
            <div className="page-section">
                <div className="collapse data-filter__title-container page-section__inner">
                    <h5 className="data-filter__title">{filterText}</h5>
                </div>
                <div className="data-filter__container">
                    {localFilters.map((filter: FilterObjects) => {
                        return (
                            <div key={filter.filterKey}>
                                <div className="data-filter__options">
                                    <DataFilterOption
                                        isRadio={filter.filterKey === filterOptions.history.filterKey}
                                        filterKey={filter.filterKey}
                                        filterTitle={getText(`pages.dataSets.filterOptions.${filter.filterKey}.text`)}
                                        filterItems={filter.items}
                                        onUpdate={onUpdate}
                                        showSearch={filter.showSearch}
                                    />
                                </div>
                                <Divider />
                            </div>
                        );
                    })}
                </div>
                <div className="data-filter-button-panel">
                    <Button
                        text={applyText}
                        hasIcon={false}
                        className="data-filter__apply"
                        theme="primary"
                        isFullWidth
                        onClick={onApply}
                    />
                    <button
                        type="button"
                        className="data-filter__clear-all links--secondary"
                        onClick={onClearAll}
                        data-testid="data-filter-clear-all"
                    >
                        {clearAllText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DataFilterOptions;
